import { Checkbox } from '@rocketlane/ui';
import { defaultTheme, components as SelectComponents } from 'react-select';
import styled from 'styled-components';

const StyledOption = styled(SelectComponents.Option).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})`
  padding: var(--spacing-01) var(--spacing-05);
  height: 32px;
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  border-radius: var(--border-radius-default);
  &:hover {
    background-color: var(--cell-hover);
  }
  cursor: pointer;
  &.ozone-select__option--is-selected {
    background-color: var(--blue-20);
    color: inherit;
    &:hover {
      background-color: var(--blue-20);
    }
  }
  &.ozone-select__option--is-focussed {
    background-color: var(--gray-10);
    color: inherit;

    &:hover {
      background-color: var(--gray-10);
    }
  }
`;
const CheckboxWrapper = styled.div`
  padding: var(--spacing-01);
  pointer-events: none;
`;

/**
 * if you want to extend this to include different types, please check the implementation of virtualized-menu-list.tsx as well
 */
export const Option = (props) => {
  return (
    <StyledOption {...props}>
      <CheckboxWrapper>
        <Checkbox
          checked={props.isSelected}
          label={props.data.label}
          color={props.selectProps?.checkboxColor}
        />
      </CheckboxWrapper>
    </StyledOption>
  );
};
